import { useNavigate } from 'react-router';
import { Box, Link, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

import { usePageTitle } from '../../../hooks/usePageTitle';
import useDateTimeFormat from '../../../hooks/useDateTimeFormat';
import { AppUser } from '../../../types/AppUser';

export default function AppUserDetail({ appUser, showBackButton = true }: { appUser: AppUser; showBackButton?: boolean }) {
  const { toStandardDate, withTimeMode } = useDateTimeFormat();
  const navigate = useNavigate();
  usePageTitle(appUser?.email, { replaceBaseTitle: true });

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row', padding: '0 0.5em 0 0', justifyContent: 'space-between' }}>
        <h1 style={{ display: 'flex', margin: 0, marginBottom: '0.5em' }}>{appUser?.fullName}</h1>
        {showBackButton && (
          <div style={{ display: 'flex' }}>
            <Link href='#' onClick={() => navigate('/users')} underline='none' sx={{ display: 'flex' }}>
              <ArrowBack sx={{ marginRight: '4px' }} />
              <Typography variant='body1' sx={{ display: 'inline' }}>
                Back to Overview
              </Typography>
            </Link>
          </div>
        )}
      </Box>
      <table>
        <tbody>
          <tr>
            <td>
              <b>Firstname:</b>
            </td>
            <td>{appUser.firstName}</td>
          </tr>
          <tr>
            <td>
              <b>Lastname:</b>
            </td>
            <td>{appUser.lastName}</td>
          </tr>
          <tr>
            <td>
              <b>Email:</b>
            </td>
            <td>{appUser.email}</td>
          </tr>
          <tr>
            <td>
              <b>{withTimeMode('Last login')}:</b>
            </td>
            <td>{toStandardDate(appUser.lastLoginDateTime)}</td>
          </tr>
          <tr>
            <td>{appUser.isLocked ? 'This user is <b>LOCKED OUT</b>' : ''}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
}
